<template>
    <div v-if="permission && permission.version === '5'" class="fluid page_content">
        <div class="row page-heading">
            <div class="col-8 input module_heading" role="heading" aria-level="1">
                <span class="module_icon icon-course"></span>
                <span class="module_type_name ace_sec_hd">
                  {{ $tf('myCourseSections') }}
                </span>
            </div>
        </div>

        <div class="course-management-section">

            <div class="page_subheading">
                <div class="col-5" style="padding-left: 0px;">
                  <div class="search_field">
                    <input
                      v-model="name"
                      :placeholder="$tf('searchByCourseTitle__pH')"
                      aria-label="search by title"
                      @input="resetPage"
                      style="float: left;">
                    <div class="clear-btn"
                      v-if="name.length > 0"
                      @click="loadCourseList">
                        <b-btn
                          @click="name = ''"
                          aria-label="clear">
                          X
                        </b-btn>
                    </div>
                  </div>
                </div>
                <div class="col-7 btn_container pagination_sty3">
                    <button type="button" :disabled="firstPage" v-on:click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                    <span class="page_count" aria-hidden="true">{{ page + 1  }}</span>
                    <select v-model="pageSize" @change="resetPage" aria-label="page size" class="page_size">
                        <option v-for="option in sizeOptions" v-bind:value="option">
                        {{ option }}
                        </option>
                    </select>
                    <span class="page_count">{{ totalofElements }} of {{ totalElements }}</span>
                    <button type="button" :disabled="lastPage" v-on:click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
                </div>
            </div>
            <div class="course-management-table-container pg_list">

              <template v-if="isCoursesLoaded">
                <template v-if="courses.length > 0">

                  <div class="row list_row lst_pg__row lst_pg__row_v1" v-for="course in courses">
                    <div class="col-12 row_data">
                      <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-4 col-sm-12 col_title">
                          <a href="javascript://" @click="goToCourseDashboard(course.uuid)">
                            <span class="ic icon-course"></span>
                            <span class="txt">{{ course.title }}</span>
                          </a>
                          <template v-if="course.master">
                            <div class="icon-master">m</div>
                          </template>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 sub_title">
                          <a href="javascript://" @click="goToCourseGrading(course.uuid)" v-if="course.pendingManualGradedKC>0">
                            <span class="ic ic24-GradePending"></span>
                            <span class="txt">
                              {{ $tf('gradesPending') }}
                              {{course.pendingManualGradedKC}}
                            </span>
                          </a>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col_date">
                          {{getFormattedDateTime(course.lastUpdatedTime)}}
                        </div>
                      </div>
                    </div>
                    <!--
                    <div class="col-1 action_menu_container">
                    </div>
                    -->
                  </div>

                  </template>
                  <template v-else>
                    <div class="no_data pt-5" style="text-align: center;">
                      {{ $tf('noResult') }}
                    </div>
                  </template>
                </template>

                <!--
                <table v-if="isCoursesLoaded" class="table b-table table-bordered border">
                    <thead class="thead-light text-center">
                        <tr>
                          <th class="second-column">Course Title</th>
                          <th class="fourth-column">Grades Pending</th>
                          <th class="last-column">Date Updated</th>
                        </tr>
                    </thead>
                    <tbody v-if="courses.length > 0">
                        <tr v-for="course in courses">
                            <td class="second-column">
                                <a href="javascript://" @click="goToCourseDashboard(course.uuid)">
                                  <span class="ic icon-course"></span>
                                  <span class="title">{{ course.title }}</span>
                                </a>
                                <template v-if="course.master">
                                    <div class="icon-master">m</div>
                                </template>
                            </td>
                            <td class="fourth-column" >
                            <a href="javascript://" @click="goToCourseGrading(course.uuid)" v-if="course.pendingManualGradedKC>0" >
                            Grades Pending {{course.pendingManualGradedKC}}
                            </a>
                            </td>
                            <td class="last-column">{{ getFormattedDateTime(course.lastUpdatedTime) }}</td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                        	<td colspan="5" class="no-result" style="text-align: center;">No Results Found</td>
                        </tr>
                    </tbody>
                </table>
                -->

            </div>
        </div>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                </div>
            </b-modal>
        </div>

    </div>

</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import '../../../assets/module/css/course/courseList.min.css'
  export default {
    name: 'my-course-sections',
    data () {
      return {
        courses: [],
        pageSize: 50,
        sizeOptions: [ 50, 100 ],
        firstPage: true,
        lastPage: false,
        page: 0,
        totalElements: 0,
        totalofElements: 0,
        name: '',
        selected: [],
        selectAll: false,
        isCoursesLoaded: false,
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      }
    },

    mounted () {
      this.loadPermission().then(res => {
        this.$refs.loadingModal.show()
        setTimeout(() => {
          this.loadCourseList()
        }, 500)
      })
    },

    methods: {
      ...mapActions([
        'loadAllCourses',
        'loadAllMyCourses',
        'loadPermission'
      ]),

      loadCourseList () {
        this.loadAllMyCourses({page: this.page, count: this.pageSize, title: this.name}).then(result => {
          this.courses = result.content
          this.firstPage = result.first
          this.lastPage = result.last
          this.page = result.number
          this.totalElements = result.totalElements
          this.totalofElements = this.totalElements > ((this.page+1)*this.pageSize)?((this.page+1)*this.pageSize):this.totalElements
          this.$refs.loadingModal.hide()
          this.isCoursesLoaded = true
          if (this.selectAll) {
            this.selected = []
            this.selectAll = false
          }
        })
      },

      goToCourseDashboard (uuid) {
        this.$store.commit('LOAD_COURSE', {})
        this.$store.commit('LOAD_CLASS_SUMMARY', {})
        return this.$router.push({name: 'courseDashboardInstructor', params: { uuid: uuid }})
      },
      goToCourseGrading (uuid) {
        this.$store.commit('LOAD_COURSE', {})
        this.$store.commit('LOAD_CLASS_SUMMARY', {})
        return this.$router.push({name: 'grading', params: { uuid: uuid }})
      },

      resetPage () {
        this.page = 0
        this.loadCourseList()
      },

      prev () {
        this.page -= 1
        this.loadCourseList()
      },

      next () {
        this.page += 1
        this.loadCourseList()
      },

      getFormattedDateTime (timeInMillis) {
        if (timeInMillis === 0) {
          return 'N/A'
        }
        var d
        var str = ''
        d = new Date(timeInMillis)
        str += String(this.months[d.getMonth()])
        str += ' ' + d.getDate()
        str += ', ' + d.getFullYear()
        var amPm = ''
        var currHour = d.getHours()
        if (currHour < 12) {
          amPm = 'AM'
        } else {
          amPm = 'PM'
        }
        if (currHour === 0) {
          currHour = 12
        }
        if (currHour > 12) {
          currHour = currHour - 12
        }
        var currMin = d.getMinutes()
        currMin = currMin + ''
        if (currMin.length === 1) {
          currMin = '0' + currMin
        }
        str += ' ' + currHour
        str += ':' + currMin
        str += ' ' + amPm
        return str
      }
    },
    computed: {
      ...mapState({
        'permission': state => state.user.permission
      })
    }
  }
</script>

<style scoped>
    .icon-master {
        float: right !important;
        margin-top: 0px !important;
        margin-left: 0px !important;
    }
</style>



// WEBPACK FOOTER //
// src/app/course/components/MyCourseSections.vue